/* istanbul ignore file */
import FatalErrorModal from './FatalErrorModal'
import { connect } from 'react-redux'
import { hasError } from '../../selectors/error'
import { navigateTo } from 'rental-car-contract/js/actions/navigation'
import Routes from 'commons/js/routes/routes'

function mapStateToProps (state) {
    return {
        error: hasError(state),
    }
}

function mapDispatchToProps (dispatch) {
    return {
        onGoHome () {
            dispatch(navigateTo({
                urlTo: Routes.rentalCarSitePath(),
            }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(FatalErrorModal)
